// Central API base for frontend. CRA reads REACT_APP_API_URL at build time.
// Default to local backend for development. Set REACT_APP_API_URL when you
// want to point the frontend at a remote backend (e.g. Render) during build.
export const API_BASE =
  process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

export function url(path) {
  // ensure no double slashes
  if (!path) return API_BASE;
  return `${API_BASE.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
}
